import Image from 'next/image'
import LinkLocale from '../../../modules/i18n/LinkLocale'
import urls from '../../../modules/urls'
import { buildSanityImage } from '../../../modules/utils'

const BlogDesktopMainPostSection = ({ thumbnail, mainPost }) => {
  const { title, subtitle, tagLists } = mainPost

  return (
    <LinkLocale href={urls.student.landing.blog.detail(mainPost.slug.current)}>
      <div className={style.mainPostSectionLayout}>
        <div className="relative h-[352px] w-[664px]">
          <Image
            fill
            src={buildSanityImage(thumbnail).fit('max').url()}
            className="rounded-[8px] object-cover"
            alt={thumbnail.alt}
            loading="lazy"
            quality={100}
          />
        </div>

        <div className={style.descriptionSectionWrapper}>
          <div className={style.descriptionSection}>
            <div>
              <div className={style.descriptionCategoryWrapper}>
                <div className="">{mainPost.category}</div>
                <div className="border-r-1 mx-[12px] h-[12px]"></div>
                <div className="">{mainPost.subCategory}</div>
              </div>

              <div className={style.desciprtionTitle}>{title}</div>
              {subtitle && <span className={style.descriptionSubtitle}>{subtitle}</span>}
            </div>
            <div className={style.desciprtionTagSection}>
              {tagLists.map((tagItem, i) => {
                return (
                  <LinkLocale key={i} href={urls.student.landing.blog.tags(tagItem)}>
                    <div className={style.desciprtionTags}>{tagItem}</div>
                  </LinkLocale>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    </LinkLocale>
  )
}

export default BlogDesktopMainPostSection

const style = {
  mainPostSectionLayout: `mb-[40px] flex w-full cursor-pointer flex-row gap-[40px]`,
  mainPostSectionWrapper: `py-[45px]`,
  descriptionSectionWrapper: `border-t-1 border-b-1 w-[376px] pt-[44px] pb-[45px]`,
  descriptionSection: `flex h-full flex-col justify-between`,
  descriptionCategoryWrapper: `Body2-14Md flex flex-row items-center text-gray-700`,
  desciprtionTitle: `truncate-2-lines Headline1-28Bd keep-all my-[12px]`,
  desciprtionTagSection: `flex flex-row gap-[8px]`,
  desciprtionTags: `Caption-12Bd flex rounded-[4px] bg-gray-100 py-[2px] px-[6px] text-gray-600`,
  descriptionSubtitle: `truncate-3-lines keep-all Body1-16Md min-h-[42px]  text-gray-700`,
}
